"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  createModel: () => createModel,
  default: () => index_default,
  trackerArchiveAssetsId: () => import_tracker_archive.trackerArchiveId
});
module.exports = __toCommonJS(index_exports);
var import_tracker_archive = require("@universo/tracker-archive");
const createModel = /* @__PURE__ */ __name(async () => ({}), "createModel");
var index_default = /* @__PURE__ */ __name(async () => ({}), "default");
//# sourceMappingURL=index.js.map
